<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Document Name"
                v-model="formSchema.document_name"
                :rules="[v => !!v || 'Document name is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              Upload File
              <input
                type="file"
                id="files2"
                ref="image2"
                v-on:change="handleFilesUpload()"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="primary" @click="submitOperationActivities">
        <v-icon>save</v-icon>
        {{addUpdateBtn}}
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-card-actions>
    
    <v-card class="mb-3 mt-3" color="lighten-1">
      <table border="1" class="partner_tbl">
        <tr>
          <th>SL</th>
          <th>Document Name</th>
          <th>File</th>
          <th>Action</th>
        </tr>
        <tr v-for="(val,index) in dataList" :key="index">
          <td>{{index+1}}</td>
          <td>{{val.document_name}}</td>
          <td>
            <a
              target="_blank"
              v-if="val.document_file_name"
              title="Download"
              :href="`${public_path}${val.document_file_name}`"
              download
            >
              <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
            </a>
          </td>
          <td>
            <v-btn icon class="mx-0" @click="editItem(index, val)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="deleteItem(index, val.id)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import ServerPath from "../../../../server-path/server-path";

export default {
  data() {
    return {
      valid: true,
      e1: 0,
      operation_act_id: "",

      rules: {
        decimalOnly: value => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        }
      },
      public_path: "",

      delete_id: "",
      row_index: "",
      dialog2: false,
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",

      formSchema: {
        id: 0,
        operation_act_id: this.operation_act_id,
        document_name: ""
      },
      documentFiles: [],
      dataList: []
    };
  },

  computed: {
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    this.public_path =
      ServerPath.serverPath + "/assets/projectInfo/operationActivitieFiles/";

    if (sessionStorage.getItem("operation_act_id")) {
      this.loadData();
    }
  },

  methods: {
    loadData() {
      commonService
        .getAllDataById(
          sessionStorage.getItem("operation_act_id"),
          "project-document-list"
        )
        .then(res => {
          if (res.data.length > 0) {
            this.dataList = res.data;
          }
        });
    },

    addToList() {
      var root = this;
      var a = 0;
      let formSchema = this.formSchema;
      formSchema.operation_act_id = sessionStorage.getItem("operation_act_id");

      let uploadedFiles = this.$refs.image2.files;

      if (uploadedFiles.length == 0) {
        this.message = "Upload File is empty!";
        this.snackbar = true;
        return false;
      }
      console.log("formSchema uploadedFiles", uploadedFiles);

      if (root.$refs.form.validate() && uploadedFiles.length > 0) {
        if (formSchema.id > 0) {
          root.$set(root.dataList, root.row_index, { ...formSchema });
        } else {
          formSchema.id = 0;
          root.dataList.unshift({ ...formSchema });
        }

        this.$refs.form.reset();
        document.getElementById("files2").value = null;
      }

      console.log("dataList", this.dataList);
      console.log("documentFiles", this.documentFiles);
    },

    submitOperationActivities() {
      // if (this.$refs.form.validate()) {
      this.submitForm();
      // };
    },

    submitForm() {
      //this.nextStep();

      let formSchema = this.formSchema;
      formSchema.operation_act_id = sessionStorage.getItem("operation_act_id");

      let uploadedFiles = this.$refs.image2.files;
      if (formSchema.id < 1 && uploadedFiles.length == 0) {
        //
        this.message = "Upload File is empty!";
        this.snackbar = true;
        return false;
      }


        console.log('formSchema= ', formSchema);
        //return 0;
      let formData = new FormData();

      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      }

      formData.append("dataList", JSON.stringify(formSchema));

      commonService.insertFormData(formData, "project-document").then(res => {
        if (res.status == 1) {
          this.documentFiles = [];

          if (res.action = 'edit') {
            this.$set(this.dataList, this.row_index, { ...res.data });
          } else {
            this.formSchema.id = 0;
            this.dataList.unshift({ ...res.data });
          }

          this.message = res.message;
          this.snackbar = true;
          document.getElementById("files2").value = null;
          this.close();
        }
      });
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        this.message = "You can upload jpg, jpeg, png, pdf and docx file only";
        this.snackbar = true;
        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        console.log("uploadedFiles[i] = ", uploadedFiles[0]);

        this.documentFiles = uploadedFiles;

        // for (var i = 0; i < uploadedFiles.length; i++) {
        //   this.documentFiles.push(uploadedFiles[i]);
        // }
      }
    },

    nextStep() {
      this.$emit("emitForm5", 1);
    },

    previous() {
      this.$emit("emitForm5", 3);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "project-document").then(res => {
        if (res.status == 1) {
          this.dataList.splice(row_index, 1);
          this.documentFiles = [];
        }
        this.message = res.message;
        this.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      let formSchema = this.formSchema;
      Object.keys(formSchema).forEach(function(key) {
        formSchema[key] = "";
      });
      this.$refs.form.reset();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/training/training_information/step_forms/costEntry.vue